module.exports = __webpack_public_path__ + "img/h-2.24b54612.jpg";